import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useState } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { Loader } from 'core-components/library/loader'
import settings from 'src/config/settings'

import styles from './StockImageGuideContent.module.scss'

interface IStockImageGuideContentProps {
  onClose: () => void
}

const imageUrl = `${settings.dataServerUrl}/builder/rs/forms/1073/images/StockImage.png`

export const StockImageGuideContent = ({ onClose }: IStockImageGuideContentProps) => {
  const [isLoading, setIsLoading] = useState(true)

  const handleImageLoad = () => {
    setIsLoading(false)
  }

  return (
    <div className={styles.root}>
      <h3 className={styles.header}>
        <Translation span text={getFormedEltTranslation('stock-image-guide-header')} />
      </h3>
      <Translation htmlAvailable text={getFormedEltTranslation('stock-image-guide')} />

      <div className={styles.imageWrapper}>
        <RenderWhen condition={isLoading}>
          <Loader />
        </RenderWhen>

        <img
          src={imageUrl}
          alt="Stock image guide"
          onLoad={handleImageLoad}
          className={isLoading ? styles.hidden : ''}
        />
      </div>

      <Flex justifyContent={'flex-end'}>
        <Button onClick={onClose}>
          <Translation text={getFormedEltTranslation('stock-image-guide-btn')} />
        </Button>
      </Flex>
    </div>
  )
}
